
import { router } from './main';
import store from './store';

export function routeTracker() {
	router.beforeEach((to, from, next) => {
		next();

		console.log('to: ', to);
		setTimeout(() => {
			const menus = store.state?.menus || [];
			// const dashBoardMenu = to.path === '/' && menus.find(e => e.menuUrl == '/Dashboard')
			const menu = menus.find(
				(element) =>
					to.path === element.menuUrl ||
					String(to.query?.id) === String(element.id)
			)

			if (menu) {
				console.log('menu route Tracker: ', menu);
				store.commit('setMenu', menu);
			}
		}, 200);
	});
}
